import React, { Component } from 'react';

import HomepageComponent from '../HomepageComponent/HomepageComponent';

import logo from './assets/logo-circle.svg';
import image01 from './assets/image-01.jpg';
import image02 from './assets/image-02.jpg';
import image03 from './assets/image-03.jpg';
import image04 from './assets/image-04.jpg';

import './styles/BrandHashtag.scss';

class BrandHashtag extends Component {
  constructor(props) {
    super(props);

    this.originalImages = [image01, image02, image03, image04];
    this.originalImages = this.originalImages.map((image, i) => {
      return { id: i, image: image};
    })

    this.imageIndex = 0;

    this.state = {
      images: this.originalImages,
      showTitle: true
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.addToImageArray = this.addToImageArray.bind(this);
    this.changeImageOrder = this.changeImageOrder.bind(this);
  }

  componentDidMount() {
    window.onblur = this.onMouseLeave;
    window.onfocus = this.onMouseLeave;
  }

  componentWillUnmount() {
    clearTimeout(this.t);
  }

  onMouseEnter() {
    clearTimeout(this.t);

    this.imageIndex = 0;

    this.setState({
      images: [],
      showTitle: false
    });

    this.t = setTimeout(this.addToImageArray, 800);
  }

  onMouseLeave() {
    clearTimeout(this.t);

    this.setState({
      images: this.originalImages,
      showTitle: true
    });
  }

  addToImageArray() {
    clearTimeout(this.t);

    const newImageArr = this.state.images;

    newImageArr.push(this.originalImages[this.imageIndex]);

    this.setState({
      images: newImageArr,
      showTitle: true
    });

    if (this.imageIndex < this.originalImages.length - 1) {
      this.imageIndex++;
      this.t = setTimeout(this.addToImageArray, 500);
    } else {
      this.t = setTimeout(this.changeImageOrder, 500);
    }
  }

  changeImageOrder() {
    clearTimeout(this.t);

    const newImageArr = this.state.images;
    newImageArr.push(newImageArr.shift());

    this.setState({
      images: newImageArr
    });

    this.t = setTimeout(this.changeImageOrder, 500);
  }

  render() {
    return (
      <HomepageComponent
        className="BrandHashtag"
        hoverClass="BrandHashtag--hover"
        target="_blank"
        onActivated={this.onMouseEnter}
        onDeactivated={this.onMouseLeave}
      >
        <div className="BrandHashtag-content">
          <img className="BrandHashtag-logo" src={logo} alt="" />

          {
            this.state.images.map((image, i) => {
              if (image) {
                return <img key={i} className="BrandHashtag-image" data-id={image.id} src={image.image} alt="" />
              }
            })
          }

          { this.state.showTitle ? (
            <span className="BrandHashtag-title">
              <span>MORE THAN AN</span>
              <span>ATHLETE</span>
            </span>) : null 
          }

          <span className="BrandHashtag-tag">
            #morethananathlete
          </span>
        </div>
      </HomepageComponent>
    );
  }
}

export default BrandHashtag;